/* eslint-disable react/display-name, @typescript-eslint/no-empty-function */
/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2025-05-09 18:03:23
 */
import './index.scss'
import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from 'react'
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'
import { Autoplay } from 'swiper'
import { DatePicker, Form, Row, Empty, Spin } from 'antd'
import DatesPicker from '../../../components/DatesPickerV2'
import takePhotoPersonIcon from '../../../../images/statistics/take_photo_person.png'
import noTakePhotoPersonIcon from '../../../../images/statistics/no_take_photo_person.png'
import pictureIcon from '../../../../images/statistics/picture.png'
import Viewer from '../../../components/ViewerV2'
import type { ViewerRef } from '../../../components/ViewerV2'
import { getPhotoStat } from '../../../../actions/dataStatistics'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
const { Item: FormItem } = Form
const { RangePicker } = DatePicker

// 照片类型
interface Photo {
  smallURL: string
  [key: string]: unknown
}

// 照片统计数据类型
interface PhotoStatData {
  total: number
  photoPeopleCnt: number
  unphotoPeopleCnt: number
  photoPeoples?: string[]
  unphotoPeoples?: string[]
}

// 组件 Props 类型
interface PhotoStatProps {
  handleClickReportSA?: (
    clickItem: string,
    params?: Record<string, unknown>
  ) => void
}

// 暴露的 ref 方法类型
export interface PhotoStatRef {
  refreshData: () => void
}

export default forwardRef<PhotoStatRef, PhotoStatProps>((props, ref) => {
  const { handleClickReportSA = () => {} } = props
  const dispatch = useAppDispatch()
  const userID = useAppSelector((state) => state.main.user?.user_id)
  const groupID = useAppSelector((state) => state.group.groupId)
  const [showDatePickerPane, setShowDatePickerPane] = useState(false)
  const [filterTimes, setFilterTimes] = useState<[Dayjs, Dayjs]>([
    dayjs().startOf('day'), // 当天00:00:00
    dayjs().endOf('day') // 当天23:59:59
  ])
  const [photoStatData, setPhotoStatData] = useState<PhotoStatData>({
    total: 0,
    photoPeopleCnt: 0,
    unphotoPeopleCnt: 0
  })
  const [loading, setLoading] = useState(false)
  const [photos, setPhotos] = useState<Photo[]>([])
  const viewerRef = useRef<ViewerRef>(null)
  const initialLoadRef = useRef(true)

  useEffect(() => {
    if (!initialLoadRef.current) {
      getPhotoStatData('chooseDate')
    }
  }, [filterTimes])

  useEffect(() => {
    getPhotoStatData('enterPage').finally(() => {
      initialLoadRef.current = false
    })
  }, [])

  useEffect(() => {}, [loading])

  const getPhotoStatData = async (type: string) => {
    console.log('type', type)
    try {
      setLoading(true)
      const res = await dispatch(
        getPhotoStat({
          userID: userID,
          groupID: groupID,
          filter: {
            times: {
              start: filterTimes[0].format('YYYY-MM-DD HH:mm:ss'),
              end: filterTimes[1].format('YYYY-MM-DD HH:mm:ss')
            }
          }
        })
      )
      setLoading(false)
      if (res.status === 0) {
        setPhotoStatData(res.stat)
        handlePhotoStatClickReportSA(type, {
          number1: res.stat.photoPeopleCnt,
          number2: res.stat.unphotoPeopleCnt,
          photoNum: res.stat.total
        })
        setPhotos(res.photos)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleDatesChange = (startDate: Dayjs, endDate: Dayjs) => {
    setShowDatePickerPane(false)
    setFilterTimes([startDate, endDate])
  }

  const handlePhotoStatClickReportSA = (
    clickItem: string,
    params?: Record<string, unknown>
  ) => {
    handleClickReportSA(clickItem, {
      themeType: 'photoManage',
      number1: photoStatData.photoPeopleCnt,
      number2: photoStatData.unphotoPeopleCnt,
      photoNum: photoStatData.total,
      ...params
    })
  }

  // 暴露刷新方法
  useImperativeHandle(ref, () => ({
    refreshData: () => {
      getPhotoStatData('refreshData')
    }
  }))
  return (
    <div className="photo-stat-container">
      <div className="photo-stat-title">
        <div className="title">照片统计</div>
        <Form layout="inline">
          <Row>
            <FormItem>
              <RangePicker
                value={filterTimes as [Dayjs, Dayjs]}
                open={false}
                allowClear={false}
                onOpenChange={() => {
                  setShowDatePickerPane(!showDatePickerPane)
                }}
                style={{ width: '236px' }}
              />
            </FormItem>
          </Row>
        </Form>
      </div>
      <Spin spinning={loading}>
        <div className="photo-stat-content">
          <div
            className="info"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handlePhotoStatClickReportSA('photoMemberNum')
              const queryParams = `start_time=${encodeURIComponent(
                filterTimes[0].format('YYYY-MM-DD HH:mm:ss')
              )}&end_time=${encodeURIComponent(filterTimes[1].format('YYYY-MM-DD HH:mm:ss'))}`
              localStorage.setItem(
                'unTakePhotoPersonIds',
                JSON.stringify(photoStatData.photoPeoples || [])
              )
              window.open(`/attendance/daily?${queryParams}`)
            }}
          >
            <img className="info-icon" src={takePhotoPersonIcon} alt="" />
            <div className="info-item">
              拍照人数
              <div className="info-item-value">
                {photoStatData.photoPeopleCnt}
                <span>人</span>
              </div>
            </div>
          </div>
          <div
            className="info"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handlePhotoStatClickReportSA('notPhotoMemberNum')
              const queryParams = `start_time=${encodeURIComponent(
                filterTimes[0].format('YYYY-MM-DD HH:mm:ss')
              )}&end_time=${encodeURIComponent(filterTimes[1].format('YYYY-MM-DD HH:mm:ss'))}`
              localStorage.setItem(
                'unTakePhotoPersonIds',
                JSON.stringify(photoStatData.unphotoPeoples || [])
              )
              window.open(`/attendance/daily?${queryParams}`)
            }}
          >
            <img className="info-icon" src={noTakePhotoPersonIcon} alt="" />
            <div className="info-item">
              未拍照人数
              <div className="info-item-value">
                {photoStatData.unphotoPeopleCnt}
                <span>人</span>
              </div>
            </div>
          </div>
          <div
            className="info"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handlePhotoStatClickReportSA('photoNum')
              const queryParams = `start_time=${encodeURIComponent(
                filterTimes[0].format('YYYY-MM-DD HH:mm:ss')
              )}&end_time=${encodeURIComponent(filterTimes[1].format('YYYY-MM-DD HH:mm:ss'))}`
              window.open(`/photo/all?${queryParams}`)
            }}
          >
            <img className="info-icon" src={pictureIcon} alt="" />
            <div className="info-item">
              照片数量
              <div className="info-item-value">
                {photoStatData.total}
                <span>张</span>
              </div>
            </div>
          </div>
        </div>
        <div className="swiper-box">
          {photos.length ? (
            <Swiper
              spaceBetween={20}
              slidesPerView={9}
              loop={photos.length >= 9}
              modules={[Autoplay]}
              autoplay={{ delay: 1000 }}
              breakpoints={{
                968: { slidesPerView: 5 }, // 平板
                1124: { slidesPerView: 7 }, // 小桌面
                1400: { slidesPerView: 9 }, // 中桌面
                1700: { slidesPerView: 11 }, // 大桌面
                2048: { slidesPerView: 13 }, // 超大桌面
                2400: { slidesPerView: 15 } // 超大桌面
              }}
              onSlideChange={() => console.log('slide change')}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {photos.map((ele, index) => {
                return (
                  <SwiperSlide key={index}>
                    <img
                      className="swiper-image"
                      src={ele.smallURL}
                      alt=""
                      onClick={() => {
                        handlePhotoStatClickReportSA('photo')
                        viewerRef.current?.view(index)
                      }}
                    />
                  </SwiperSlide>
                )
              })}
            </Swiper>
          ) : (
            <Empty />
          )}
        </div>
      </Spin>
      <DatesPicker
        visible={showDatePickerPane}
        dates={filterTimes as [Dayjs, Dayjs]}
        allowTime={false}
        maxMonths={1}
        onChange={handleDatesChange}
        onCancel={() => setShowDatePickerPane(false)}
      />
      <Viewer
        ref={viewerRef}
        canDelete={false}
        canRectify={false}
        canAiSecurity={false}
        photos={photos}
        showWatermarkAction={false}
        fromPlace={'dataStatisticPhotoManage'}
      />
    </div>
  )
})
